import type { ReactNode } from 'react';

interface CardProps {
    title?: string;
    subtitle?: string;
    headerActions?: ReactNode;
    children: ReactNode;
    footer?: ReactNode;
    className?: string;
    headerClassName?: string;
    bodyClassName?: string;
    footerClassName?: string;
    responsivePadding?: boolean; // Enable responsive padding
}

const Card = ({
    title,
    subtitle,
    headerActions,
    children,
    footer,
    className = '',
    headerClassName = '',
    bodyClassName = '',
    footerClassName = '',
    responsivePadding = false
}: CardProps) => {
    // Define responsive padding classes
    const headerPadding = responsivePadding ? 'px-3 py-2 sm:px-4 sm:py-3 md:px-6 md:py-4' : 'px-6 py-4';
    const bodyPadding = responsivePadding ? 'p-2 sm:p-4 md:p-6' : 'p-6';
    const footerPadding = responsivePadding ? 'px-3 py-2 sm:px-4 sm:py-3 md:px-6 md:py-4' : 'px-6 py-4';

    return (
        <div className={`bg-[#1a1a1a] border border-zinc-800 rounded-lg shadow-md ${className}`}>
            {(title || subtitle || headerActions) && (
                <div className={`${headerPadding} border-b border-zinc-800 ${headerClassName}`}>
                    <div className="flex items-start justify-between gap-4">
                        <div>
                            {title && <h5 className="text-xl font-semibold mb-0">{title}</h5>}
                            {subtitle && <h6 className="text-sm text-zinc-500 mt-1">{subtitle}</h6>}
                        </div>
                        {headerActions && <div className="shrink-0">{headerActions}</div>}
                    </div>
                </div>
            )}
            <div className={`${bodyPadding} ${bodyClassName}`}>{children}</div>
            {footer && <div className={`${footerPadding} border-t border-zinc-800 ${footerClassName}`}>{footer}</div>}
        </div>
    );
};

export default Card;
